import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 300px;
  right: 370px;
  background-color: rgba(0, 0, 0, 0.85);
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.7), 0 4px 10px rgba(0, 0, 0, 0.5),
    0 10px 25px rgba(0, 0, 0, 0.4), 0 30px 50px rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  user-select: none;
  padding: 8px;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0 5px 5px;
`;

export const Header = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 260px;
`;

export const Image = styled.img`
  width: 280px;
  height: 280px;
  margin: 10px;
  border-radius: 50%;
  filter: brightness(1.1) contrast(1.1);
`;
